import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'zeroToNull' })
export class ZeroToNullPipe implements PipeTransform {
  transform(value: any, formPristine: boolean): any {
    if (value === 0 && formPristine) {
      return null;
    }
    return value;
  }
}
